<form #form class="flex flex-column gap-8 min-width-zero">
	<div class="error" [class.show]="showErrorMessage">{{ errorMessage }}</div>
	<label for="employee-number">
		{{ 'mes.mes-production-terminal.employeekey-enter.label' | translate }}
	</label>
	<div class="flex">
		<input type="text" name="employee-number" spellcheck="false" [(ngModel)]="inputData" #employeeNumberInputField [readonly]="!!employeeService.currentEmployee" [value]="getCurrentEmployeeMessage()" [ngClass]="{ 'gray-background': employeeService.currentEmployee }" autocomplete="off" />
		<div class="button" (click)="onButtonClick()">
			<div>
				{{ employeeService.currentEmployee ? ('mes.mes-production-terminal.employeekey-enter.back-btn' | translate) : ('mes.mes-production-terminal.employeekey-enter.nxt-btn' | translate) }}
			</div>
			<div class="icon">
				<img [src]="employeeService.currentEmployee ? './assets/mes/terminal/arrow--left.svg' : './assets/mes/terminal/arrow--right.svg'" />
			</div>
		</div>
	</div>
</form>
